import debounce from "lodash/debounce"
import { saveSearchTermBypassLength, MINIMUM_SEARCH_TERM_LENGTH } from "app/components/universal_search/search_history"

export const TrackEvents = () => {
  const searchInput = document.querySelector("#explore-search input") as HTMLInputElement
  const allContainer = document.querySelector(".explore-discover-results")
  const serviceContainer = document.querySelector("div.web-services-container")
  const searchResultContainer = document.querySelector(".search-view-container")

  const onClickDiscoverItem = (actionName: string, data) => {
    window.App.Utils.logCustomDatadogAction("explore_click_any_result", data)
    window.App.Utils.logCustomDatadogAction(actionName, data)
  }

  const saveShortSearchTermHandler = () => {
    const term = searchInput.value
    if (term && term.length < MINIMUM_SEARCH_TERM_LENGTH) {
      saveSearchTermBypassLength({ type: "search", term })
    }
  }

  allContainer.addEventListener("click", event => {
    const tile = event.target.closest("[data-type]")
    if (!tile) return

    onClickDiscoverItem(`explore_click_get_more_${tile.dataset.type}`, {
      searchResultType: tile.dataset.type,
      searchResultId: tile.dataset.id,
    })

    saveShortSearchTermHandler()
  })

  serviceContainer.addEventListener("click", event => {
    const tile = (event.target as Element)?.closest("[data-type]") as HTMLElement
    if (!tile) return

    const isFiltered = document.querySelector(".service-category-filter").value !== "All"

    onClickDiscoverItem(`explore_click_${isFiltered ? "filtered_category_service_result" : "get_more_service"}`, {
      searchResultType: tile.dataset.type,
      searchResultId: tile.dataset.id,
    })

    saveShortSearchTermHandler()
  })

  searchResultContainer.addEventListener("click", event => {
    const tile = event.target.closest("[data-type]")
    if (!tile) return

    onClickDiscoverItem(`explore_click_${tile.dataset.type}_search_result`, {
      searchResultType: tile.dataset.type,
      searchResultId: tile.dataset.id,
    })

    saveShortSearchTermHandler()
  })

  let scrollTimeout: number | null = null

  const debouncedHandleScrollToBottom = debounce(() => {
    const scrollTop = window.scrollY
    const documentHeight = document.documentElement.scrollHeight
    const windowHeight = window.innerHeight

    if (scrollTimeout) clearTimeout(scrollTimeout)

    if (scrollTop + windowHeight >= documentHeight) {
      const searchTerm = searchInput?.value || ""
      const activeElement = document.querySelector(".filter-content-list > a.active") as HTMLElement
      const currentView = searchTerm ? "search" : activeElement?.dataset?.target || ""

      scrollTimeout = window.setTimeout(() => {
        window.App.Utils?.logCustomDatadogAction("get_more_scroll_to_bottom", {
          currentView,
          searchTerm,
        })
      }, 1000)
    }
  }, 150)

  window.addEventListener("scroll", debouncedHandleScrollToBottom)
}
